/* eslint-disable @typescript-eslint/indent */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
import {
  type ReadonlySignal,
  type Signal,
  signal,
  computed,
} from '@preact/signals-react'

import type {
  EApplicationType,
  TApplication,
  TApplicationFilters,
  TApplicationsState,
  TApplicationStateLoading,
} from '@/interfaces'

import { ConvocatoriasState } from '../convocatorias'
import { FormState } from '../form'

import { filterApplications } from './utils'

const applications: Signal<TApplication[]> = signal([])

const currentApplicationType: Signal<EApplicationType | null> = signal(null)

const canCreateApplication: ReadonlySignal<boolean> = computed(() => {
  return Boolean(
    ConvocatoriasState.currentConvocatoria.value.id &&
      ConvocatoriasState.currentConvocatoria.value.isActive &&
      ConvocatoriasState.currentCity.value &&
      !FormState.showForm.value
  )
})

const currentEntityTableData: Signal<TApplication[]> = signal([])

const currentEntityFilesData: Signal<Record<string, string>> = signal({})

const currentApplication: Signal<TApplication | null> = signal(null)

const filteredApplications: ReadonlySignal<TApplication[]> =
  computed(filterApplications)

const loading: Signal<TApplicationStateLoading> = signal({
  changeStatus: {},
  deletingRow: false,
  export: false,
  getAll: false,
  getById: false,
  import: false,
  saving: false,
  savingRow: false,
})

const showCreateAlert: Signal<boolean> = signal(true)

const viewMode: Signal<{ edit: boolean; view: boolean }> = signal({
  edit: false,
  view: false,
})

const filters: Signal<TApplicationFilters> = signal({
  status: null,
  text: null,
  type: null,
})

const showFilters: Signal<boolean> = signal(false)

const openImportModal: Signal<boolean> = signal(false)

const importApplicationType: Signal<EApplicationType | null> = signal(null)

const modalInhabilitacion = signal<{ visible: boolean; detalle: string; cedula?: string }>({
  visible: false,
  detalle: '',
  cedula: undefined,
})

export const ApplicationsState: TApplicationsState = {
  applications,
  canCreateApplication,
  currentApplication,
  currentApplicationType,
  currentEntityFilesData,
  currentEntityTableData,
  filteredApplications,
  filters,
  importApplicationType,
  loading,
  modalInhabilitacion,
  openImportModal,
  showCreateAlert,
  showFilters,
  viewMode,
}
